import { Box, Card, CardHeader, Divider } from '@mui/material'
import React from 'react'

import ChatInput from './ChatInput'
import ConnectionStatus from './ConnectionStatus'
import MessageList from './MessageList'

/**
 * ChatContainer - Main container for chat interface
 *
 * @param {Array} messages - Array of message objects
 * @param {function} onSendMessage - Callback when user sends a message
 * @param {string} currentUserId - ID of the current user
 * @param {string} title - Chat title/header
 * @param {string} subtitle - Chat subtitle (e.g., participant info) - deprecated, use connectionState instead
 * @param {Object} avatar - Avatar component for header
 * @param {Object} action - Action component for header (e.g., menu button)
 * @param {boolean} fullScreen - Whether the chat is in full screen mode
 * @param {string} connectionState - WebSocket connection state ('connected', 'connecting', 'disconnected', 'error')
 * @param {Object} sx - Additional styles to apply
 */
export default function ChatContainer({ messages = [], onSendMessage, currentUserId, title = 'Chat', subtitle, action, backButton, fullScreen = false, connectionState, sx = {} }) {
  // Disable input when connection is not ready
  const isInputDisabled = connectionState !== 'connected'
  return (
    <Card
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        ...sx,
      }}
    >
      {title && (
        <>
          <CardHeader
            avatar={backButton}
            action={action}
            title={title}
            subheader={fullScreen && connectionState ? <ConnectionStatus connectionState={connectionState} /> : fullScreen ? subtitle : undefined}
            sx={{ px: 3, py: 1, m: 0 }}
          />
          <Divider />
        </>
      )}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          minHeight: 0,
        }}
      >
        <MessageList messages={messages} currentUserId={currentUserId} />
        <ChatInput onSend={onSendMessage} disabled={isInputDisabled} placeholder={isInputDisabled ? 'Waiting for connection...' : 'Type a message...'} />
      </Box>
    </Card>
  )
}
